import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import * as d3 from "d3";

@Component({
  selector: 'app-injection-graph',
  templateUrl: './injection-graph.component.html',
  styleUrls: ['./injection-graph.component.css']
})
export class InjectionGraphComponent implements OnInit {

  @ViewChild("graphFigure") graphFigure: ElementRef;

  public svg: any;

  private width: number = 600;
  private height: number = 400;
  private marginLeft: number = 50;
  private marginRight: number = 50;
  private marginTop: number = 10;
  private marginBottom: number = 30;
  
  

  private _injData: Array<any>;

  @Input()
  set injData(value: Array<any>) {

    this._injData = value;

    this.initGraph();
  }

  get injData(): Array<any> {
    return this._injData;
  }

  constructor() {
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.initGraph();
  }

  //Adds a legend to the D3 object given by "svg," which is obviously supposed to be SVG.
  protected addGraphLegend(svg: any, classes: Array<any>) {

    var legendMargin = 10;

    var legendG = svg.append("g");

    var legendLineStepHeight = 30;

    var legendBodyHeight = legendLineStepHeight * classes.length;
    var legendBodyWidth = 240;

    var legendHeight = (legendMargin * 2) + legendBodyHeight;
    var legendWidth = (legendMargin * 2) + legendBodyWidth;

    legendG.attr("transform", "translate(" + (this.marginLeft + this.width - legendWidth) + ", " + this.marginTop + ")");

    //Legend neatline
    legendG.append("rect")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", legendWidth)
      .attr("height", legendHeight)
      .style("fill", "black")
      .style("fill-opacity", "0.1")
      .style("stroke", "black");

    for (var i = 0; i < classes.length; i++) {

      legendG.append("circle")
        .attr("cx", 10)
        .attr("cy", (i * legendLineStepHeight) + 0.5 * legendLineStepHeight + legendMargin)
        .attr("r", 6)
        .style("fill", classes[i].color);

      legendG.append("text")
        .attr("x", 30)
        .attr("y", (i * legendLineStepHeight) + 0.5 * legendLineStepHeight + legendMargin)
        .text(classes[i].label)
        .style("font-size", "12px")
        .attr("alignment-baseline", "middle");
    }

  }

  protected initGraph() {

    if (this.injData != null && this.injData.length > 0 && this.graphFigure != null) {

      var _this = this;

      var classes = [];

      this.svg = d3.select(this.graphFigure.nativeElement)
        .append("svg")
        .attr("width", this.width + this.marginLeft + this.marginRight)
        .attr("height", this.height + this.marginTop + this.marginBottom)
        .append("g")
        .attr("transform", "translate(" + this.marginLeft + "," + this.marginTop + ")");

      this.svg.append("rect")
        .attr("width", this.width)
        .attr("height", this.height)
        .attr("transform", "translate(" + this.marginLeft + "," + this.marginTop + ")")
        .style("fill", "rgb(255,255,255)");


      var timeExtent = d3.extent(this.injData, function (d) {
        return d.attributes.InjectionDate;
      })

      //Create the X axis
      var x = d3.scaleTime()
        .domain(timeExtent)
        .range([0, this.width]);

      //Actually add the axis to our graph
      this.svg.append("g")
        .attr("transform", "translate(0, " + this.height + ")")
        .call(d3.axisBottom(x));

      var yAxisLeftDomain = d3.extent(this.injData, function (d) {
        return d.attributes.VolumeInjectedBBL;
      });

      var yAxisLeftRange = yAxisLeftDomain[1] - yAxisLeftDomain[0];

      var yAxisRightDomain = d3.extent(this.injData, function (d) {
        return d.attributes.TotalGasVolumeMCF;
      });

      var yAxisRightRange = yAxisRightDomain[1] - yAxisRightDomain[0];

      //Check if we have a non-zero data range before we display the left hand axis
      if (yAxisLeftRange > 0) {

        yAxisLeftDomain[1] += yAxisLeftRange * 0.2;

        var c = "green";

        //Create the Y axis
        var yLeft = d3.scaleLinear()
          .domain(yAxisLeftDomain)
          .range([this.height, 0]);

        //Actually draw the axis
        this.svg.append("g")
          .call(d3.axisLeft(yLeft));

        //Actually draw the injection volume line
        this.svg.append("path")
          .datum(this.injData)
          .attr("fill", "none")
          .attr("stroke", c)
          .attr("stroke-width", 1.5)
          .attr("d", d3.line()
            .x(function (d: any) { return x(d.attributes.InjectionDate); })
            .y(function (d: any) { return yLeft(d.attributes.VolumeInjectedBBL); })
          );

        var dClass = {
          color: c,
          label: "Volume Injected (BBLs)"
        };

        classes.push(dClass);
      }

      //Check if we have a non-zero data range before we display the right hand axis
      if (yAxisRightRange > 0) {

        yAxisRightDomain[1] += yAxisRightRange * 0.2;

        var c = "red";

        //Draw the right-hand y axis
        var yRight = d3.scaleLinear()
          .domain(yAxisRightDomain)
          .range([this.height, 0]);

        this.svg.append("g")
          .call(d3.axisRight(yRight));

        this.svg.append("path")
          .datum(this.injData)
          .attr("fill", "none")
          .attr("stroke", "red")
          .attr("stroke-width", 1.5)
          .attr("d", d3.line()
            .x(function (d: any) { return x(d.attributes.InjectionDate); })
            .y(function (d: any) { return yRight(d.attributes.TotalGasVolumeMCF); })
        );

        var dClass = {
          color: c,
          label: "Total Gas Volume (MCF)"
        };

        classes.push(dClass);
      }

      var mouse_g = this.svg.append("g").classed("mouse", true).style("display", "none");
      mouse_g.append('rect').attr("width", 2).attr("x", -1).attr("height", this.height).attr("fill", "lightgray");
      mouse_g.append("circle").attr("r", 3).attr("stroke", "steelblue");
      mouse_g.append("text").attr("transform", "translate(0, 15)")

      this.svg.on("mouseover", function (mouse) {
        mouse_g.style("display", "block");
      });

      this.svg.on("mouseout", function (mouse) {
        mouse_g.style("display", "none");
      });

      var firstDate = timeExtent[0];
      var lastDate = timeExtent[1];

      var timeSpan = lastDate - firstDate;

      this.svg.on("mousemove", function (mouse) {
        var mouseCoords = d3.pointer(mouse);

        var ratio = mouseCoords[0] / _this.width;

        var pointerDate = (ratio * timeSpan) + firstDate;

        var dpDate = new Date(pointerDate);

        mouse_g.attr("transform", `translate(${x(pointerDate)}, ${0})`);

        var dateString = dpDate.toLocaleDateString();

        mouse_g.select("text").text(dateString)
          .attr('text-anchor', ratio < 0.5 ? "start" : "end");

        var closest = null;
        var closestDiff = null;

        for (var i = 0; i < _this.injData.length; i++) {
          var rec = _this.injData[i];

          var diff = Math.abs(pointerDate - rec.attributes.InjectionDate);

          if (closestDiff == null || diff < closestDiff) {
            closestDiff = diff;
            closest = rec;
          }
        }

        if (closest != null) {
          mouse_g.select("circle").attr("cy", yLeft(closest.attributes.VolumeInjectedBBL))
          mouse_g.select("text").text(dateString + ": " + closest.attributes.VolumeInjectedBBL.toString() + " bbl")
            .attr('text-anchor', ratio < 0.5 ? "start" : "end");
        }
        

      });

      this.addGraphLegend(this.svg, classes);
    }
  }

}
